import { resolveCleroPlusEnabled } from './webPaymentFlow.mjs';

export const WEB_PAYMENTS_CONFIG_COLLECTION = 'appConfig';
export const WEB_PAYMENTS_CONFIG_DOCUMENT = 'feature_flags';
export const WEB_PAYMENTS_ENABLED_FIELD = 'webPaymentsEnabled';

export const isWebPaymentsEnabled = (data: unknown): boolean => {
  if (!data || typeof data !== 'object') return false;
  return (data as { webPaymentsEnabled?: unknown }).webPaymentsEnabled === true;
};

export const isCleroPlusEnabled = (data: unknown): boolean => {
  return resolveCleroPlusEnabled(data);
};
